import { type FC } from "react";
import { SectionTitle } from "@root/userFrontend/components/SectionTitle";
import * as styles from "./styles.css";
// uiParts
import { ReviewContent } from "./uiParts/ReviewContent";
// types
import { type Props } from "./type";

export const TreatmentAndCulture: FC<Props> = ({
  questions,
  checkboxValues,
  handleCheckboxChange,
  isDisabled,
  treatmentsErrorText,
  culturesErrorText,
  treatmentsRef,
  culturesRef,
}) => {
  return (
    <>
      <div className={styles.sectionOuter}>
        <SectionTitle text="待遇面の口コミ" />
        <div className={styles.container}>
          <ReviewContent
            questions={questions.treatmentQuestions}
            categoryName="treatments"
            checkboxValues={checkboxValues}
            handleCheckboxChange={handleCheckboxChange}
            errorText={treatmentsErrorText}
            isDisabled={isDisabled}
            containerRef={treatmentsRef}
          />
        </div>
      </div>
      <div className={styles.sectionOuter}>
        <SectionTitle text="社風面の口コミ" />
        <div className={styles.container}>
          <ReviewContent
            questions={questions.cultureQuestions}
            categoryName="cultures"
            checkboxValues={checkboxValues}
            handleCheckboxChange={handleCheckboxChange}
            errorText={culturesErrorText}
            isDisabled={isDisabled}
            containerRef={culturesRef}
          />
        </div>
      </div>
    </>
  );
};
